import * as React from 'react';
import AssetsManager from '../../../common/utils/AssetsManager';

export default class FooterView extends React.Component<{}, {year: number}> {
    constructor(props) {
        super(props);
        const d = new Date();
        this.state = {
            year: d.getFullYear()
        };
    }

    render() {
        return (
            <footer className="container">
                <div className="border-top pb-1">
                    <div className="row d-none d-sm-none d-md-block pt-4 pb-1">
                        <div className="col">
                            <img className="navbar-brand-img-sm" alt="motorfy"
                                 src={AssetsManager('/assets/images/common/motorfy.svg')}/>
                        </div>
                    </div>
                    <div className="row pt-3">
                        <div className="col-lg-6 col-sm-12">
                            <p className="text-muted small text-center text-md-left">
                                Preguntas y comentarios contáctate con nosotros:
                                <br/> Telf: (55) 4161-8830 · email:
                                <a href="mailto:ayuda@@motorfy.com">
                                    <strong className="text-info">ayuda@motorfy.com</strong></a>
                            </p>
                        </div>
                        <div className="col-lg-6 col-sm-12">
                            <p className="text-muted small text-center text-md-right">
                                Usar este sitio implica aceptar nuestros <br/>
                                <a href="https://www.seminuevos.com/terminos-y-condiciones" target="_blank">
                                    <strong className="text-info"> Términos y Condiciones </strong>
                                </a> de Uso.
                            </p>
                        </div>
                    </div>
                    <div className="row pt-1">
                        <div className="col-lg-8 col-sm-12">
                            <p className="text-muted small text-center text-md-left">
                                Copyright © {this.state.year}
                                <a href="http://www.motorfy.com/">
                                    <strong className="text-info"> Motorfy.com</strong>
                                </a> | Dirección: Hipólito Taine 244, Colonia Polanco V Sección, Miguel Hidalgo, C.P.
                                11560 Ciudad de México, CDMX
                            </p>
                        </div>
                        <div className="col-lg-4 col-sm-12">
                            <p className="text-muted small text-center text-md-right">
                                <a href="https://s3.amazonaws.com/static.latamautos.com/motorfy/condiciones-motorfy.pdf"
                                   target="_blank">
                                    <strong className="text-info">
                                        Consulta las condiciones de nuestros productos
                                    </strong>
                                </a>
                            </p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="offset-lg-6 col-lg-6 col-sm-12">
                            <p className="text-muted small text-center text-md-right">
                                Con el respaldo de:
                                <a href="http://www.seminuevos.com/">
                                    <img className="navbar-brand-img-md pl-1" alt="seminuevos"
                                         src={AssetsManager('/assets/images/common/logo-seminuevos.svg')}/>
                                </a>
                            </p>
                        </div>
                    </div>
                </div>
            </footer>
        );
    }
}